import React from 'react';
import TitleImg from '../../images/end__title.png';
import '../EndPage.scss';
import {EveryonesSmile} from "./../EveryonesSmile";

type P = {
    onDone: () => void;
};

export const EndPage = (props: P) => {

    return (
        <div className='end'>
            <div className="end__title-container">
                <h1><img width={1236 / 2} height={154 / 2} src={TitleImg} alt=""/></h1>
            </div>

            <div className='end__text-1'>みんなの笑顔の展示の予定は<br/>&gt;&nbsp;<a className='end__future'
                                                                        href="https://hikarino-mi.jp/future">こちら</a>をご覧ください
            </div>

            <EveryonesSmile mobile={true}/>

        </div>
    );
};